import { get, isBoolean } from 'lodash';

import { State } from 'src/global/store';

export const getIsPhoneNumberMandatoryForSignup = (state: State) => {
  const isPhoneNumberMandatoryForSignup = get(
    state.generalConfig,
    'signup.isPhoneNumberMandatoryForSignup'
  );

  if (isBoolean(isPhoneNumberMandatoryForSignup)) {
    return isPhoneNumberMandatoryForSignup;
  }

  return false;
};
